import PdfCertificate from './PdfCertificate';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons';

export default function PdfButton(props) {
  return (
    <PDFDownloadLink
      document={<PdfCertificate {...props.documentInfo} />}
      fileName={`WhiteTowerSponsorshipCertificate-${props.stoneId}.pdf`}
      className="btn btn-dark d-block"
    >
      {({ blob, url, loading, error }) =>
        loading ? (
          'Loading document...'
        ) : (
          <>
            Download Certificate
            <FontAwesomeIcon icon={faArrowCircleDown} className="ml-2" />
          </>
        )
      }
    </PDFDownloadLink>
  );
}
